// extracted by mini-css-extract-plugin
export default {"label":"FormSelect_label__KNW0d","fieldset":"FormSelect_fieldset__EnYRf","caretDown":"FormSelect_caretDown__SfVQ8","labelWeight":"FormSelect_labelWeight__gSqZL"};